module.exports = __webpack_public_path__ + "assets/img/213b097988641f707790fd1d7c35e297.png";